import { render, staticRenderFns } from "./ListService.vue?vue&type=template&id=58667b7c&scoped=true&"
import script from "./ListService.vue?vue&type=script&lang=js&"
export * from "./ListService.vue?vue&type=script&lang=js&"
import style0 from "./ListService.vue?vue&type=style&index=0&id=58667b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58667b7c",
  null
  
)

export default component.exports